import { BaseSopOperation } from "./_Base";
import { TypedNodePathParamValue } from "../../../core/Walker";
import { GlobalsGeometryHandler } from "../../../engine/nodes/gl/code/globals/Geometry";
import { ObjectTypeByObject } from "../../../core/geometry/Constant";
import { CoreMaterial } from "../../../core/geometry/Material";
import { NodeContext } from "../../../engine/poly/NodeContext";
import { CoreInstancer } from "../../../core/geometry/Instancer";
import { InputCloneMode } from "../../../engine/poly/InputCloneMode";
import { isBooleanTrue } from "../../../core/BooleanValue";
export class InstanceSopOperation extends BaseSopOperation {
  static type() {
    return "instance";
  }
  async cook(input_contents, params) {
    const core_group_to_instance = input_contents[0];
    this._geometry = void 0;
    const object_to_instance = core_group_to_instance.objectsWithGeo()[0];
    if (object_to_instance) {
      const geometry_to_instance = object_to_instance.geometry;
      if (geometry_to_instance) {
        const core_group = input_contents[1];
        this._createInstance(geometry_to_instance, core_group, params);
      }
    }
    if (this._geometry) {
      const type = ObjectTypeByObject(object_to_instance);
      if (type) {
        const object = this.createObject(this._geometry, type);
        if (isBooleanTrue(params.applyMaterial)) {
          const material = await this._getMaterial(params);
          if (material) {
            await this._applyMaterial(object, material);
          }
        }
        return this.createCoreGroupFromObjects([object]);
      }
    }
    return this.createCoreGroupFromObjects([]);
  }
  async _getMaterial(params) {
    var _a;
    if (isBooleanTrue(params.applyMaterial)) {
      const materialNode = params.material.nodeWithContext(NodeContext.MAT, (_a = this.states) == null ? void 0 : _a.error);
      if (materialNode) {
        this._globalsHandler = this._globalsHandler || new GlobalsGeometryHandler();
        const matBuilderNode = materialNode;
        const matNodeAssemblerController = matBuilderNode.assemblerController();
        if (matNodeAssemblerController) {
          matNodeAssemblerController.setAssemblerGlobalsHandler(this._globalsHandler);
        }
        const container = await materialNode.compute();
        const material = container.material();
        return material;
      }
    }
  }
  async _applyMaterial(object, material) {
    object.material = material;
    CoreMaterial.applyCustomMaterials(object, material);
  }
  _createInstance(geometry_to_instance, template_core_group, params) {
    this._geometry = CoreInstancer.createInstanceBufferGeometry(geometry_to_instance, template_core_group, params.attributesToCopy);
  }
}
InstanceSopOperation.DEFAULT_PARAMS = {
  attributesToCopy: "instance*",
  applyMaterial: true,
  material: new TypedNodePathParamValue("")
};
InstanceSopOperation.INPUT_CLONED_STATE = [InputCloneMode.ALWAYS, InputCloneMode.NEVER];
